import { render, staticRenderFns } from "./ModalErroCoberturaVigente.vue?vue&type=template&id=12387425&scoped=true"
import script from "./ModalErroCoberturaVigente.vue?vue&type=script&lang=ts"
export * from "./ModalErroCoberturaVigente.vue?vue&type=script&lang=ts"
import style0 from "./ModalErroCoberturaVigente.vue?vue&type=style&index=0&id=12387425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12387425",
  null
  
)

export default component.exports